import script from "./AnnualFundraisingSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualFundraisingSummary.vue?vue&type=script&setup=true&lang=js"

import "./AnnualFundraisingSummary.vue?vue&type=style&index=0&id=79f30e6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f30e6d"]])

export default __exports__